module.exports = __webpack_public_path__ + "static/media/ET188 new.0a812b7a.jpg";